import { mountGame } from '../render/three/game-app.js';
import { golfSpec } from '../variants/golf/spec.js';

await mountGame(golfSpec);
